import "./footer.css";
import { useItems } from "../../contexts/item_context";

export default function Footer() {
    const { analyzeString, getJsonValidation } = useItems();
    const { lines, words, characters, bytes } = analyzeString();
    const { isValid, error } = getJsonValidation();

    return (
        <div className="status-bar">
            {/* JSON Validation */}
            <div className={`status-segment status-segment--validation ${isValid === true ? "valid" : isValid === false ? "invalid" : "neutral"}`}>
                {isValid === true && (
                    <>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        Valid JSON
                    </>
                )}
                {isValid === false && (
                    <>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <span className="validation-error" title={error}>JSON Error</span>
                    </>
                )}
                {isValid === null && <span>—</span>}
            </div>

            <div className="status-divider" />

            {/* Stats */}
            <div className="status-segment">
                <span className="stat-label">Ln</span>
                <span className="stat-value">{lines}</span>
            </div>
            <div className="status-segment">
                <span className="stat-label">Words</span>
                <span className="stat-value">{words}</span>
            </div>
            <div className="status-segment">
                <span className="stat-label">Chars</span>
                <span className="stat-value">{characters}</span>
            </div>
            <div className="status-segment">
                <span className="stat-label">Size</span>
                <span className="stat-value">{bytes}</span>
            </div>
        </div>
    );
}
